import { useNativeState } from '@shared/core/native';
import { BoxProps } from '@withjoy/joykit';
import React from 'react';

import { StyledPage, styles } from './LayoutStructure.styles';
import { useRouteMatch } from '@shared/core';
import { useCatalogRoutePaths } from '@apps/registry/common/components/Catalog/Catalog.routes';

interface PageProps extends Readonly<BoxProps> {}

export const Page: React.FC<PageProps> = props => {
  const { isNative } = useNativeState();
  const { catalogRoutes } = useCatalogRoutePaths();

  const isShopRootRouteMatch = useRouteMatch({ path: catalogRoutes.catalogIndex.paths, exact: true });

  return (
    <StyledPage
      __css={styles.page}
      paddingTop={isNative ? 8 : { _: 0, md: isShopRootRouteMatch ? 0 : 7 }}
      {...props}
    />
  );
};
